import {$requestsList} from "./stores.js";
import {getRequestsListFx} from "./effects.js";

$requestsList.on(getRequestsListFx.doneData, (state, payload) => payload)
